import { Injectable } from '@angular/core';
import { ShopinfoModel } from './model/shopinfo.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class ShopinfoService {

  constructor(private http: HttpClient) { }

  getShopList(requestData:RequestData): Observable<any> {
    return this.http.post(environment.baseUrl+'/common/shop/get', requestData);

  }
  getShopById(id:number): Observable<any> {
    return this.http.post(environment.baseUrl+'/common/shop/get/'+id, '');

  }

  
  
  getShopTypeList() {
    return this.http.get(environment.baseUrl + '/common/shop/getShopTypeList');
  }

   /**
   * 
   * @param shopInfo 
   * Calls the update API to insert/update the record
   */
   update(shopInfo: ShopinfoModel): Observable<any> { 
    if(shopInfo.hasOwnProperty("id")){
      return this.http.post(environment.baseUrl+'/common/shop/update', shopInfo);
    } else{
      return this.http.post(environment.baseUrl+'/common/shop/add', shopInfo);
    }
  }


    /**
   * 
   * @param shopInfo 
   * Calls the API to delete the record
   */
    delete(shopInfo: ShopinfoModel): Observable<any>  {
      return this.http.post(environment.baseUrl+'/common/shop/delete/'+shopInfo.id, shopInfo);
    }

    downloadExcel(requestData: any): Observable<Blob> {
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
     // const url = 'http://yourdomain.com/api/customers/export'; // Adjust URL
  
      return this.http.post(environment.baseUrl + '/common/shop/export-shop-list', requestData, { headers, responseType: 'blob' })
        .pipe(
          //catchError(this.handleError)
        );
  
    }
}
